export const SHOW_MODAL_FOR_DOMAIN_PART = 'SHOW_MODAL_FOR_DOMAIN_PART';
export const HIDE_MODAL_FOR_DOMAIN_PART = 'HIDE_MODAL_FOR_DOMAIN_PART';
export const MINIMIZE_MODAL_FOR_DOMAIN_PART = 'MINIMIZE_MODAL_FOR_DOMAIN_PART';
export const RESTORE_MODAL_FOR_DOMAIN_PART = 'RESTORE_MODAL_FOR_DOMAIN_PART';
export const UPDATE_MODAL_LAYOUT_DATA = 'UPDATE_MODAL_LAYOUT_DATA';
export const CLOSE_ALL_OPENED_MODALS = 'CLOSE_ALL_OPENED_MODALS';
